import { Form, Input } from 'antd';
import { CompWithFormProp } from '../../constants/constants';

export const Objectives = ({ form }: CompWithFormProp) => {
  const selectedGrade = Form.useWatch(
    ['registration', 'selectedSubject'],
    form,
  );

  return (
    <Form.Item
      label="Tikslai"
      name={['registration', 'objectives']}
      style={{ display: selectedGrade ? 'block' : 'none' }}
    >
      <Input.TextArea rows={2} />
    </Form.Item>
  );
};
